var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgPdf = function SvgPdf(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8716_8132)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.24609 23.248H2.24609C1.84827 23.248 1.46674 23.09 1.18543 22.8087C0.904129 22.5274 0.746094 22.1459 0.746094 21.748V2.24805C0.746094 1.85022 0.904129 1.46869 1.18543 1.18739C1.46674 0.906082 1.84827 0.748047 2.24609 0.748047H12.8751C13.0722 0.748089 13.2673 0.78697 13.4494 0.862467C13.6314 0.937965 13.7968 1.0486 13.9361 1.18805L19.8071 7.05905C19.9464 7.1984 20.0568 7.36383 20.1321 7.54588C20.2075 7.72793 20.2462 7.92303 20.2461 8.12005V12.748",
    stroke: "#030F40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2461 8.24805H14.2461C13.8483 8.24805 13.4667 8.09001 13.1854 7.80871C12.9041 7.5274 12.7461 7.14587 12.7461 6.74805V0.748047",
    stroke: "#030F40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24609 23.248V15.748",
    stroke: "#030F40",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.24609 15.748H9.00009C9.59683 15.748 10.1691 15.9851 10.5911 16.4071C11.013 16.829 11.2501 17.4013 11.2501 17.998C11.2501 18.5948 11.013 19.1671 10.5911 19.589C10.1691 20.011 9.59683 20.248 9.00009 20.248H8.25009",
    stroke: "#3D466C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.2461 23.248C15.0417 23.248 15.8048 22.932 16.3674 22.3694C16.93 21.8068 17.2461 21.0437 17.2461 20.248V18.748C17.2461 17.9524 16.93 17.1893 16.3674 16.6267C15.8048 16.0641 15.0417 15.748 14.2461 15.748V23.248Z",
    stroke: "#3D466C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2461 23.248V17.248C20.2461 16.8502 20.4041 16.4687 20.6854 16.1874C20.9667 15.9061 21.3483 15.748 21.7461 15.748H23.2461",
    stroke: "#3D466C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2461 20.248H22.4961",
    stroke: "#3D466C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8716_8132"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgPdf);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/pdf.76012a243dc2a6fb084f7a80ca91c4d6.svg";